// extracted by mini-css-extract-plugin
export default {"cls1":"NavigationDrawerFlyoutMenu-Anchor_cls1__0eIeL","cls2":"NavigationDrawerFlyoutMenu-Anchor_cls2__l06OV NavigationDrawerFlyoutMenu-Anchor_cls1__0eIeL"};